import React from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import rightArrow from "assets/icons/arrow-right-landing.png";

const InfoBox = (props) => {
  const { infoText, linkText, headingText } = props;
  return (
    <Box className="info-box">
      {headingText?.length > 0 && (
        <Typography variant="h2" className="heading-text">
          {headingText}
        </Typography>
      )}
      <Typography
        className={`${headingText?.length > 0 ? "info-text2" : "info-text"}`}
        variant="body2"
        component="div"
      >
        {infoText}
      </Typography>
      {linkText?.length > 0 && (
        <Box component="div" className="animated-link">
          <Typography variant="subtitle2" className="link-text">
            {linkText}
          </Typography>
          <Box className="right-arrow">
            <img src={rightArrow} width="25px" />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default InfoBox;
